<template>
  <master-layout id="gicContentBookmark" no-bottom-pad>
    <div
      class="w-[100vw] overflow-x-hidden overflow-y-scroll flex flex-col lg:flex-1 h-[calc(100svh-73px)] font-aktiv-grotesk pb-[64px] md:pb-[104px]">
      <!-- iOS override: --safe-area-inset-top is not populated on iOS, so
           pt-safe-top collapses to 16px there — 60px is the app-wide iOS
           notch clearance (same as the video pages' containers) -->
      <div
        class="w-full md:max-w-[896px] md:mx-auto px-[24px] pt-safe-top md:pt-[40px] lg:px-0"
        :class="{ '!pt-[60px]': isIos }"
      >
        <BackButton variant="bare" class="mb-[24px]" :is-gic="true" @click="back" />
        <div v-if="!showLoading">
          <p class="text-grey-100 text-[32px] leading-[40px] mt-[24px] font-aktiv-grotesk-medium">
            {{ myListHeader }}
          </p>
          <div v-if="
            allBookMarkList.length &&
            allBookMarkList[0].resources && allBookMarkList[0].resources.length
          ">
            <!-- eslint-disable-next-line vue/require-v-for-key -->
            <div v-for="item in allBookMarkList" class="mt-[16px]">
              <div class="mt-[36px] flex flex-row flex-wrap gap-x-[16px] gap-y-[16px] md:gap-y-[64px]">
                <ResourceCard v-for="resource in item.resources" :key="`${resource.slug}-${item.type}`"
                  :image-url="resource.thumbnail" :title="resource.title" :slug="resource.slug" :type="resource.type"
                  :tag-slug="tagSlug" :duration="resource.duration" :is-exclusive="resource.isCVPExclusive"
                  :is-audio="resource.isAudio" :avail-translations="resource.availTranslations"
                  :resource-translations="resource.resourceTranslations" class="!pr-0" @openLanguageModal="() => { }" />
              </div>
            </div>
          </div>
          <div v-else>
            <div class="text-center mt-[60px] ">
              <h1 class="text-[24px] leading-[32px] font-bold">Your List is Empty</h1>
              <p class="mt-[16px] text-[16px] leading-[20px]">As you explore resources, tap the <img
                  src="/assets/images/bookmark.svg" alt="bookmark" class="inline" /> icon <br /> to save it here.</p>
            </div>
          </div>
        </div>
        <div v-else class="w-full min-h-[50svh] flex items-center justify-center">
          <loading-state />
        </div>
      </div>
    </div>
  </master-layout>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import ResourceCard from "@/components/ResourcesPage/PlaybackResources/ResourceCard.vue";
import { bookmark } from "ionicons/icons";
import LoadingState from "@/components/common/LoadingState.vue";
import BackButton from "@/components/common/BackButton.vue";
import platformMixin from '@/mixins/platformMixin';

export default {
  name: "ResourceSearch",
  mixins: [platformMixin],
  components: {
    ResourceCard,
    LoadingState,
    BackButton,
  },
  data() {
    return {
      bookmarkIcon: bookmark,
    };
  },
  computed: {
    ...mapState("filter", ["allBookMarkList", "isLoading"]),
    ...mapGetters("filter", ["myListHeader"]),
    // Blocking spinner only on true first load — cached bookmarks render
    // immediately while the refetch updates in the background.
    showLoading() {
      return this.isLoading && !this.allBookMarkList.length;
    },
  },
  async ionViewDidEnter() {
    const locale = "en";
    await Promise.all([
      await this.$store.dispatch("filter/fetchBookMarkLists", {
        locale: locale,
        conferenceType: "GIC",
      }),
    ]);
  },
  async ionViewWillLeave() { },
  methods: {
    back() {
      this.$router.back();
    },
  },
};
</script>
<style scoped>
@media all and (min-width: 768px) {
  ::v-deep(.swiper-wrapper) {
    padding-left: 0;
  }
}
</style>
